import RestApiModel from "@/api/Model/RestApiModel";

class SavedQuote extends RestApiModel {
  static getResourceEndpoint() {
    return '/savequote';
  }
}

export default SavedQuote;
